import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { ProveedorAvisos } from './componentes/ui'
import './estilos/base.css'

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      // Varias personas trabajan sobre las mismas 39 concesiones, así que
      // conviene volver a leer al recuperar el foco. Medio minuto de caché
      // alcanza para que navegar entre vistas no dispare consultas de más.
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
})

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <QueryClientProvider client={cliente}>
      <BrowserRouter>
        <ProveedorAvisos>
          <App />
        </ProveedorAvisos>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
